module.exports = __webpack_public_path__ + "e0a7d947992bc302528b1bca7944994e.glb";